<template>
  <component :is="tag" class="editorial-section">
    <div class="section-inner">
      <h2 v-if="blok.title" class="title size-xl align-center margin">
        {{ blok.title }}
      </h2>
      <StoryblokComponent
        v-for="item in blok.items"
        :key="item._uid"
        :blok="item"
        class="margin"
      />
    </div>
  </component>
</template>

<script setup>
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
  tag: {
    type: String,
    required: false,
    default: "div",
  },
});
</script>

<style lang="scss" scoped>
.editorial-section {
  :deep(.margin):not(:last-child) {
    margin-bottom: 5rem;
    @include for-tablet-landscape-up {
      margin-bottom: 6.25rem;
    }
  }
  :deep(.staff-testimonial) {
    padding-top: 0;
    padding-bottom: 0;
    @include pair-7;
    @include for-tablet-landscape-up {
      display: flex;
      flex-direction: row;
      align-items: center;
      .staff-testimonial--header {
        margin-bottom: 0;
        order: 2;
        flex-direction: column;
        text-align: center;
      }
      .staff-testimonial--quote {
        width: 70%;
      }
    }
  }
}
</style>

<style lang="scss">
.editorial-section .media-text-cta {
  @include for-tablet-landscape-up {
    &.is-special {
      width: auto;
    }
  }
  &:first-child {
    margin-top: 0;
  }
}
.background-facility-overview
  + .background.background-editorial-section.alternate {
  @include pair-3;
  .staff-testimonial {
    @include pair-3;
  }
}
</style>
